"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PageFilterContainer = exports.TitleBar = void 0;
var react_1 = __importStar(require("react"));
var inversify_react_1 = require("inversify-react");
var react_transition_group_1 = require("react-transition-group");
var BemBuilder_1 = __importDefault(require("@CommonFrontend/Utils/BemBuilder"));
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var CurrencySelector_1 = require("Project/Actions/ManualPageValue/CurrencySelector");
var AdminOnly_1 = require("Utils/AdminOnly");
var MobileOnly_1 = require("Utils/MobileOnly");
var UpgradeContainer_1 = require("Common/Upgrade/UpgradeContainer");
var UpgradeTooltip_1 = require("Common/Upgrade/UpgradeTooltip");
var MobileUpgradeModal_1 = require("Common/Upgrade/MobileUpgradeModal");
var UpgradeConstants_1 = require("Common/Upgrade/UpgradeConstants");
var ReportsOwnerFilter_1 = require("./ReportsOwnerFilter/ReportsOwnerFilter");
var ReportsCleanup_1 = require("./ReportsCleanup/ReportsCleanup");
var ReportsPageSetFilter_1 = __importDefault(require("./ReportsPageSetFilter/ReportsPageSetFilter"));
var Types_1 = require("./Types");
var CollapsableItemList_1 = require("./Common/CollapsableItemList");
var c = (0, BemBuilder_1.default)("reports-title-bar");
var getYearOption = function (isEnterprisePlan, isMobile) {
    if (isEnterprisePlan) {
        return {
            label: "Year",
            value: Types_1.TimePeriod.YEAR,
        };
    }
    var upgradeComponent = isMobile ? (react_1.default.createElement(MobileUpgradeModal_1.MobileUpgradeModal, { key: "Year", telemetryOrigin: "pipeline_report_year_period_hover" },
        react_1.default.createElement(react_1.default.Fragment, null, "Year"))) : (react_1.default.createElement(UpgradeTooltip_1.UpgradeTooltip, { key: "Year", texts: {
            heading: UpgradeConstants_1.UPGRADE_HEADING,
            subtitleAdmin: UpgradeConstants_1.PIPELINE_REPORT_UPGRADE_SUBTITLE_ADMIN,
            subtitleCreator: UpgradeConstants_1.PIPELINE_REPORT_UPGRADE_SUBTITLE_CREATOR,
        }, telemetryOrigin: "pipeline_report_year_period_hover" },
        react_1.default.createElement(react_1.default.Fragment, null, "Year")));
    return {
        label: upgradeComponent,
        value: Types_1.TimePeriod.YEAR,
        disabled: true,
    };
};
var TitleBar = function (_a) {
    var title = _a.title, usersList = _a.usersList, sessionUser = _a.sessionUser, selectedOwner = _a.selectedOwner, selectedCurrency = _a.selectedCurrency, currentPageFilter = _a.currentPageFilter, selectedPageCollection = _a.selectedPageCollection, cleanupFilters = _a.cleanupFilters, handleOwnerSelect = _a.handleOwnerSelect, handlePageFilterChange = _a.handlePageFilterChange, selectedTimePeriod = _a.selectedTimePeriod, handleTimePeriodSelect = _a.handleTimePeriodSelect, handleCurrencySelect = _a.handleCurrencySelect, handleCleanupFilters = _a.handleCleanupFilters, handlePageCollection = _a.handlePageCollection;
    var isMobile = (0, inversify_react_1.useInjection)("isMobile")();
    var isEnterprisePlan = (0, UpgradeContainer_1.useIsEnterprisePlan)();
    var _b = __read((0, react_1.useState)(false), 2), openFiltersOnMobile = _b[0], setOpenFiltersOnMobile = _b[1];
    var yearOption = getYearOption(isEnterprisePlan, isMobile);
    function selectRelativeTimePeriod(timePeriod) {
        handleTimePeriodSelect(__assign(__assign({}, selectedTimePeriod), { timePeriod: timePeriod, customPeriod: undefined }));
    }
    return (react_1.default.createElement("div", { className: c() },
        react_1.default.createElement("div", { className: c("header") },
            react_1.default.createElement(kaleidoscope_1.Heading, { level: "2", strong: true }, title),
            react_1.default.createElement(MobileOnly_1.MobileOnly, null,
                react_1.default.createElement(kaleidoscope_1.IconButton, { isRound: true, size: kaleidoscope_1.ButtonSize.Small, type: kaleidoscope_1.ButtonType.Secondary, icon: react_1.default.createElement(icons_1.Filter, null), onClick: function () { return setOpenFiltersOnMobile(!openFiltersOnMobile); } }))),
        react_1.default.createElement("div", { className: c("filters", isMobile ? "mobile" : "") },
            react_1.default.createElement(kaleidoscope_1.SegmentedControl, { className: c("filters__time-period"), label: "Time period", selectedValue: selectedTimePeriod.timePeriod, onClickHandler: selectRelativeTimePeriod, labelHidden: true, options: [
                    { label: "Week", value: Types_1.TimePeriod.WEEK },
                    { label: "Month", value: Types_1.TimePeriod.MONTH },
                    { label: "Quarter", value: Types_1.TimePeriod.QUARTER },
                    __assign({}, yearOption),
                ] }),
            react_1.default.createElement(FiltersMobileContainer, { isMobile: isMobile, isOpenOnMobile: openFiltersOnMobile },
                react_1.default.createElement(ReportsOwnerFilter_1.ReportsOwnerFilter, { sessionUser: sessionUser, usersList: usersList, selectedOwner: selectedOwner, handleOwnerSelect: handleOwnerSelect, buttonClassName: isMobile ? c("button-filter-mobile") : "", buttonEndIcon: isMobile ? react_1.default.createElement(icons_1.ChevronDown, null) : undefined }),
                react_1.default.createElement(CurrencySelector_1.CurrencySelector, { buttonClassName: isMobile ? c("button-filter-mobile") : "", label: isMobile ? "currency" : "", currentCurrency: selectedCurrency, onChange: function (currency) { return handleCurrencySelect(currency); }, bottomElement: react_1.default.createElement(AdminOnly_1.AdminOnly, null,
                        react_1.default.createElement("div", { className: c("update-default-currency") },
                            react_1.default.createElement(kaleidoscope_1.Link, { href: "/#/settings/reporting", target: "_blank" }, "Update default currency"))) }),
                react_1.default.createElement(exports.PageFilterContainer, { isMobile: isMobile, filterName: "Saved Filters", icon: react_1.default.createElement(icons_1.PageSet, { color: "default" }), popoverSize: kaleidoscope_1.PopoverSize.Auto },
                    react_1.default.createElement(ReportsPageSetFilter_1.default, { currentPageFilter: currentPageFilter, selectedPageCollection: selectedPageCollection, handlePageFilterChange: handlePageFilterChange, handlePageCollection: handlePageCollection, isMobile: isMobile })),
                react_1.default.createElement(exports.PageFilterContainer, { isMobile: isMobile, filterName: "Clean up", icon: react_1.default.createElement(icons_1.Spark, { color: "default" }), popoverSize: kaleidoscope_1.PopoverSize.Medium },
                    react_1.default.createElement(ReportsCleanup_1.ReportsCleanup, { cleanupFilters: cleanupFilters, setCleanupFilters: handleCleanupFilters }))))));
};
exports.TitleBar = TitleBar;
var FiltersMobileContainer = function (_a) {
    var isMobile = _a.isMobile, isOpenOnMobile = _a.isOpenOnMobile, children = _a.children;
    if (!isMobile) {
        return react_1.default.createElement(react_1.default.Fragment, null, children);
    }
    var containerClass = c("container-mobile");
    return (react_1.default.createElement(react_transition_group_1.Transition, { mountOnEnter: true, unmountOnExit: true, in: isOpenOnMobile, timeout: kaleidoscope_1.AnimationDuration.Medium },
        react_1.default.createElement("div", { className: containerClass },
            react_1.default.createElement(kaleidoscope_1.Heading, { level: "4", strong: true }, "Filter Options"),
            react_1.default.Children.map(children, function (element) {
                return react_1.default.cloneElement(react_1.default.createElement("div", { className: "".concat(containerClass, "__filter-item") }, element));
            }))));
};
var PageFilterContainer = function (_a) {
    var isMobile = _a.isMobile, filterName = _a.filterName, icon = _a.icon, popoverSize = _a.popoverSize, children = _a.children;
    if (isMobile) {
        return (react_1.default.createElement(CollapsableItemList_1.CollapsableItemList, { label: filterName, icon: icon }, children));
    }
    return (react_1.default.createElement(kaleidoscope_1.Popover, { size: popoverSize, position: kaleidoscope_1.PopoverPosition.Bottom, button: function (buttonProps) { return (react_1.default.createElement(kaleidoscope_1.Button, __assign({ type: kaleidoscope_1.ButtonType.Tertiary }, buttonProps),
            icon,
            filterName)); }, autoStack: true }, children));
};
exports.PageFilterContainer = PageFilterContainer;
